import { Accordion } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import { CustomBlock, TechSpecs as TechSpecsType } from '@/entities/product';
import AccordionSection from './AccordionSection';
import TechSpecs from './TechSpecs';

interface CustomBlocksProps {
  techSpecs?: TechSpecsType;
  description?: ReactNode;
  customBlocks?: CustomBlock[];
}

const AccordionBlocks = ({ techSpecs, description, customBlocks }: CustomBlocksProps) => {
  const { t } = useTranslation();

  return (
    <Accordion
      allowMultiple
      w='full'
    >
      {description && (
        <AccordionSection title={t('store.product.accordion.description')}>
          {typeof description === 'string' ? t(description) : description}
        </AccordionSection>
      )}

      {techSpecs && (
        <AccordionSection title={t('store.product.accordion.techSpecs')}>
          <TechSpecs techSpecs={techSpecs} />
        </AccordionSection>
      )}

      {customBlocks?.map(({ title, content, isTranslationKey }) => (
        <AccordionSection
          key={title}
          title={isTranslationKey ? t(title) : title}
        >
          {isTranslationKey && typeof content === 'string' ? t(content) : content}
        </AccordionSection>
      ))}
    </Accordion>
  );
};

export default AccordionBlocks;
